import React from "react";
import { MarketplaceBanner } from "../../blocks/marketplace-banner";
import { MarketplaceCreateApp } from "../../blocks/marketplace-create-app";
import { MarketplaceList } from "../../blocks/marketplace-list";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";

// import { MarketplaceHeader } from "../../components/MarketplaceHeader";
import "./styles.less";

export const MarketplacePage = (props) => {
  const { macketplaceData } = props;
  return (
    <div className="marketplace-page">
      <Header />
      {/* <MarketplaceHeader /> */}
      <MarketplaceBanner />
      <MarketplaceList macketplaceData={macketplaceData} />
      <MarketplaceCreateApp />
      <Footer />
    </div>
  );
};
